/* ============================================================
   BKFX carruseles - Claude 24 sep 2026
   Pone las flechas DENTRO del carrusel, centradas sobre la imagen o
   el video (no abajo). Calcula la posición y la deja en variables CSS
   (--bkfx-a-top, --bkfx-a-left, --bkfx-a-right) que usa el bloque 10
   de bkfx-ux.css. Si este archivo no carga, las flechas se quedan
   como estaban.
   ============================================================ */
(function () {
  function rel(box, host) {
    var a = box.getBoundingClientRect();
    var h = host.getBoundingClientRect();
    return { top: a.top - h.top, left: a.left - h.left, right: h.right - a.right, height: a.height };
  }
  /* La imagen que más se ve dentro de "clip" (no la primera: en loop hay
     diapositivas escondidas a los lados que asoman unos pixeles) */
  function visibleMedia(root, sel, clip) {
    var hr = (clip || root).getBoundingClientRect();
    var els = root.querySelectorAll(sel);
    var best = null, bestArea = 0;
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.width < 60 || r.height < 60) continue;
      var w = Math.min(r.right, hr.right) - Math.max(r.left, hr.left);
      var h = Math.min(r.bottom, hr.bottom) - Math.max(r.top, hr.top);
      if (w <= 0 || h <= 0) continue;
      if (w * h > bestArea) { bestArea = w * h; best = els[i]; }
    }
    return best;
  }
  function place(host, box, inset) {
    if (!host || !box) return;
    var r = rel(box, host);
    if (r.height < 60) return;
    /* Imagen chica (logos de Normativa): flechas en las orillas del carrusel y en navy */
    var small = host.tagName === 'SLIDER-COMPONENT' && box.getBoundingClientRect().width < host.getBoundingClientRect().width * 0.6;
    host.style.setProperty('--bkfx-a-top', Math.round(r.top + r.height / 2) + 'px');
    host.style.setProperty('--bkfx-a-left', Math.round(small ? inset : Math.max(r.left, 0) + inset) + 'px');
    host.style.setProperty('--bkfx-a-right', Math.round(small ? inset : Math.max(r.right, 0) + inset) + 'px');
    host.classList.toggle('bkfx-arrows-light', small);
    host.classList.add('bkfx-arrows-in');
  }
  function run() {
    document.querySelectorAll('#MainContent slider-component').forEach(function (s) {
      if (s.classList.contains('thumbnail-slider')) return;
      var m = visibleMedia(s, '.slider__slide img, .slider__slide video, .slider__slide .placeholder-svg');
      if (m) place(s, m, 10);
    });
    /* Carrusel de problemas: la foto cambia de lado en cada diapositiva.
       Las flechas se quedan fijas (no brincan bajo el mouse), a la altura
       del centro de la foto. Si hay espacio gris a los lados del contenido
       (escritorio) van ahí, en navy, sin tapar texto; si no (celular) van
       dentro, sobre la foto, en blanco. */
    document.querySelectorAll('[class*="ai-story-container-"]').forEach(function (c) {
      var wrap = c.querySelector('[class*="ai-story-slides-wrapper-"]') || c;
      var m = visibleMedia(c, 'img, video', wrap);
      if (!m) return;
      var r = rel(m, c), w = rel(wrap, c);
      if (r.height < 60) return;
      c.style.setProperty('--bkfx-a-top', Math.round(r.top + r.height / 2) + 'px');
      var wr = wrap.getBoundingClientRect();
      var room = Math.min(wr.left, document.documentElement.clientWidth - wr.right) >= 72;
      c.style.setProperty('--bkfx-a-left', Math.round(room ? w.left - 60 : Math.max(w.left, 0) + 12) + 'px');
      c.style.setProperty('--bkfx-a-right', Math.round(room ? w.right - 60 : Math.max(w.right, 0) + 12) + 'px');
      c.classList.add('bkfx-arrows-in');
      var mr = m.getBoundingClientRect();
      c.querySelectorAll('[class*="ai-story-arrow-"]').forEach(function (a) {
        var ar = a.getBoundingClientRect(), cx = (ar.left + ar.right) / 2;
        a.classList.toggle('bkfx-arrow-dark', !(cx > mr.left && cx < mr.right));
      });
    });
    document.querySelectorAll('.jdgm-videos-carousel').forEach(function (w) {
      var c = w.querySelector('.jdgm-content');
      if (c) place(w, c, 12);
    });
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(run, 120); }
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  window.addEventListener('resize', soon);
  document.addEventListener('shopify:section:load', soon);
  /* Al cambiar de diapositiva, recalcular cuando termine la animación */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.slider-button, [class*="ai-story-arrow-"], [class*="ai-story-dot-"], .jdgm-arrow')) setTimeout(run, 650);
  });
  /* Judge.me y las imágenes lazy cargan tarde: repetir unos segundos */
  var n = 0;
  var iv = setInterval(function () { run(); if (++n > 16) clearInterval(iv); }, 700);
})();
